/*
    Counts mpegts.js players created and destroyed by VideoPlayer, to help find leaks: if "alive" keeps climbing as
    players should be coming and going (e.g. clicking tiles), players are not being cleaned up.
    Logs to console only if `sessionStorage.playbackConsoleLogging = 'true'` (same switch as the playback logs).
*/

const stats = { created: 0, destroyed: 0 };

const shouldLog = () => {
    try {
        return sessionStorage.playbackConsoleLogging === 'true';
    } catch (error) {
        return false;
    }
};

export const trackVideoPlayerCreated = () => {
    stats.created++;
    if (shouldLog()) {
        console.log(`[VideoPlayer] created. alive: ${stats.created - stats.destroyed} (created ${stats.created}, destroyed ${stats.destroyed})`);
    }
};

export const trackVideoPlayerDestroyed = () => {
    stats.destroyed++;
    if (shouldLog()) {
        console.log(`[VideoPlayer] destroyed. alive: ${stats.created - stats.destroyed} (created ${stats.created}, destroyed ${stats.destroyed})`);
    }
};

export const getVideoPlayerStats = () => ({ ...stats, alive: stats.created - stats.destroyed });
